import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Axios from "axios";

import PageWrapper from "../../../Components/Common/PageWrapper";
import Logo_GOLDENTREE from "../../../Resources/Images/logo.png";

import { HOST, ETHERSCAN_API_ENDPOINT, PAGE_UNIT } from "../../../Utils/constants";
import useState from "../../../Hooks/useState";
import globalContext from "../../../Hooks/globalContext";
import Loader from "../../../Components/Common/Loader";
import languagePack from "../../../Utils/language";
import { CubeIcon, LeftArrowIcon } from "../../../Components/Common/Icons";
import { numberWithCommas, dateConvertor } from "../../../Utils/util";
import Theme from "../../../Styles/Theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const EmptyLabel = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 25px;
  color: white;
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 15px;
  background-color: ${(props) => props.theme.mainColor};
  border-radius: 15px;
  :not(:last-child) {
    margin-bottom: 10px;
  }
`;

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BlockNumber = styled.div`
  font-weight: bold;
  font-size: 15px;
  color: white;
  display: flex;
  align-items: center;
  span {
    margin-left: 5px;
  }
`;

const In = styled.div`
  font-weight: bold;
  font-size: 15px;
  color: white;
`;

const Out = styled.div`
  font-weight: bold;
  font-size: 15px;
  color: #dc6f6f;
`;

const Hash = styled.div`
  font-size: 10px;
  font-weight: lighter;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.theme.lightGrey};
`;

const Left = styled.table`
  margin: 5px 0px;
  font-size: 12px;
  color: white;
  td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 10px;
    max-width: 75vw;
  }
  th {
    text-align: right;
  }
`;

const ModalTable = styled.table`
  margin: 5px 0px;
  font-size: 12px;
  th {
    padding: 10px 0px;
  }
  td {
    padding: 10px 0px 10px 10px;
    word-break: break-all;
    display: flex;
    align-items: center;
  }
  tr {
    :not(:last-child) {
      border-bottom: 1px solid ${(props) => props.theme.darkGrey};
    }
  }
`;

const Right = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: bold;
  span {
    margin-right: 2.5px;
  }
`;

const TokenIcon = styled.img`
  height: 13px;
`;

const MoreButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 15px;
`;

const MoreLabel = styled.div`
  color: ${(props) => props.theme.darkGrey};
  padding: 2.5px 5px;
`;

const ModalTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ModalTitle = styled.div`
  font-size: 22px;
  margin-bottom: 15px;
`;

const IconWrapper = styled.div`
  position: absolute;
  left: 15px;
  top: 10px;
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
`;

const Row = ({ item, user, web3, modal }) => {
  const timeStamp = new Date(Number(`${item.timeStamp}000`));
  const onClick = () => {
    modal.setState(
      <ModalTableWrapper>
        <ModalTitle>Trnasaction Receipt</ModalTitle>
        <ModalTable>
          <tbody>
            <tr>
              <th>BlockNumber</th>
              <td>#{item.blockNumber}</td>
            </tr>
            <tr>
              <th>Hash</th>
              <td>{item.hash}</td>
            </tr>
            <tr>
              <th>From</th>
              <td>{item.from}</td>
            </tr>
            <tr>
              <th>To</th>
              <td>{item.to}</td>
            </tr>
            <tr>
              <th>Date</th>
              <td>{dateConvertor(timeStamp)}</td>
            </tr>
          </tbody>
        </ModalTable>
      </ModalTableWrapper>
    );
  };
  return (
    <Item onClick={onClick}>
      <SpaceBetween>
        <BlockNumber>
          <CubeIcon size={10} color={"white"} />
          <span>{item.blockNumber}</span>
        </BlockNumber>
        {item.from === user.address.toLowerCase() ? <Out>OUT</Out> : <In>IN</In>}
      </SpaceBetween>
      <SpaceBetween>
        <Hash>{item.hash}</Hash>
      </SpaceBetween>
      <SpaceBetween>
        <Left>
          <tbody>
            <tr>
              <th>From</th>
              <td>{item.from}</td>
            </tr>
            <tr>
              <th>To</th>
              <td>{item.to}</td>
            </tr>
          </tbody>
        </Left>
      </SpaceBetween>
      <SpaceBetween>
        <div />
        <Right>
          <span>{numberWithCommas(web3.utils.fromWei(item.value))}</span>
          <span>{item.tokenSymbol}</span>
          {/* {item.tokenSymbol.toLowerCase() === "gt coin" && <TokenIcon src={Logo_GOLDENTREE} />} */}
        </Right>
      </SpaceBetween>
    </Item>
  );
};

const Page = ({ phase }) => {
  const { getTxCount, user, getUser, language, web3, modal } = useContext(globalContext);
  const page = useState(1);
  const list = useState(null);
  const isLoading = useState(false);
  const isEnd = useState(false);

  const moreOnClick = async () => {
    if (isLoading.state) {
      return;
    }
    isLoading.setState(true);
    const _page = page.state;
    page.setState(page.state + 1);
    const { data } = await Axios.post(
      `${ETHERSCAN_API_ENDPOINT({
        address: user.state.address,
        page: _page + 1,
        offset: PAGE_UNIT,
        sort: "desc",
      })}`
    );
    if (data.status === "0") {
      isLoading.setState(false);
      isEnd.setState(true);
      return;
    }
    const concat = list.state.concat(data.result);
    list.setState(concat);
    isLoading.setState(false);
  };

  const preload = async () => {
    if (user.state) {
      // const count = await getTxCount(user.state.address);
      const { data } = await Axios.post(
        `${ETHERSCAN_API_ENDPOINT({
          address: user.state.address,
          page: page.state,
          offset: PAGE_UNIT,
          sort: "desc",
        })}`
      );
      list.setState(data.result);
    }
  };

  useEffect(() => {
    preload();
  }, [user.state]);
  return (
    <Wrapper>
      <IconWrapper onClick={() => phase.setState(null)}>
        <LeftArrowIcon color={Theme.darkGrey} size={20} />
      </IconWrapper>
      {list.state ? (
        list.state.length === 0 ? (
          <EmptyLabel>{languagePack("내역이 없습니다.", language.state)}</EmptyLabel>
        ) : (
          <>
            {list.state.map((item, index) => {
              return <Row item={item} user={user.state} key={index} web3={web3} modal={modal} />;
            })}
            <MoreButton>
              {isLoading.state ? (
                <Loader fit={true} size={15} color={Theme.darkGrey} />
              ) : (
                !isEnd.state && <MoreLabel onClick={moreOnClick}>{languagePack("더 보기", language.state)}</MoreLabel>
              )}
            </MoreButton>
          </>
        )
      ) : (
        <Loader color={Theme.darkGrey} size={15} />
      )}
    </Wrapper>
  );
};

export default Page;
